import { Reducer } from "redux";
import { ICartContainerState } from "./cart";
import { ICartAction, CartActionTypes } from "./cart.actions";
import { WHITE } from "@montana/constants/colors";
import { getImageUrlFromProductImage } from "@montana/helpers/media-src.helper";

/**
 * CART TODO
 * all propperties should be optional, so that we don't have to set them in initial state.
 * totalPriceWithoutVat is propperly not what "amount" was ment to be in the designs.
*/

const initialState: ICartContainerState = {
    updateQuantityLoading: false,
    placeOrderLoading: false,
    placeOrderWasSuccess: false,
    cartId: 0,
    cartGuid: '',
    lines: [],
    accumulatedQuantity: 0
};

export const cartReducer: Reducer<ICartContainerState, ICartAction> = (state = initialState, action) => {
    switch (action.type) {
        case CartActionTypes.UPDATE_CART: {
            const deleteBuffer = state.deleteBuffer || [];
            const lines = (action.cart?.lines || []).map(line => {
                return { ...line, imageUrl: getImageUrlFromProductImage(line.productImageViewModel, WHITE) }
            });

            const updatedLines = lines.filter(l => !deleteBuffer.some(x => x.productGroupId === l.productGroupId));
            const linesToDisplay = [...updatedLines, ...deleteBuffer].sort((a, b) => a?.sortOrder - b?.sortOrder);

            return {
                ...state,
                ...action.cart,
                lines: updatedLines,
                linesToDisplay,
                accumulatedQuantity: linesToDisplay?.reduce((acc, l) => (l.quantity || 0) + acc, 0) || 0
            };
        }

        case CartActionTypes.REINSTATE_CART_LINE:
        case CartActionTypes.ADD_CART_LINE: {
            return {
                ...state,
                updateQuantityLoading: true,
            };
        }

        case CartActionTypes.UPDATE_CART_COMPLETED: {
            return {
                ...state,
                updateQuantityLoading: false,
            };
        }

        case CartActionTypes.PLACE_ORDER: {
            return {
                ...state,
                cartGhostCount: state.lines.reduce((acc, l) => (l.quantity || 0) + acc, 0),
                placeOrderLoading: true,
            };
        }

        case CartActionTypes.PLACE_ORDER_ERROR: {
            return {
                ...state,
                placeOrderLoading: false,
            };
        }

        case CartActionTypes.PLACE_ORDER_SUCCESS: {
            return {
                ...state,
                placeOrderWasSuccess: true,
                placeOrderLoading: false,
            };
        }

        case CartActionTypes.RESET_ORDER_STATE: {
            return {
                ...state,
                cartGhostCount: undefined,
                placeOrderWasSuccess: true,
                placeOrderLoading: false,
            };
        }

        case CartActionTypes.SET_DELETE_BUFFER: {
            return {
                ...state,
                deleteBuffer: action.lines,
                deleteByProductBuffer: action.linesByProduct,
            };
        }

        case CartActionTypes.ADD_VOUCHER: {
            return {
                ...state,
                addingVoucher: true,
            }
        }

        case CartActionTypes.ADD_VOUCHER_ERROR: {
            return {
                ...state,
                addingVoucher: false,
            }
        }

        case CartActionTypes.ADD_VOUCHER_SUCCESS: {
            return {
                ...state,
                addingVoucher: false,
            }
        }

        default: {
            return state;
        }
    }
};
